import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, defineMessages } from 'react-intl'
import { Flex, Box } from '@elparking/components'
import { Control } from '../Input'
import { required, password } from '../../validators'

const messages = defineMessages({
    placeholder: {
        defaultMessage: 'Contraseña',
    },
    placeholderRepeat: {
        defaultMessage: 'Repita la contraseña',
    },
    requiredError: {
        defaultMessage: 'Obligatorio',
    },
    lengthError: {
        defaultMessage: 'Debe tener como mínimo 6 caracteres',
    },
    passwordError: {
        defaultMessage: 'La contraseña debe tener como mínimo 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial',
    },
    passwordMatch: {
        defaultMessage: 'Las contraseñas deben coincidir.'
    }
})

const PasswordFieldConfirm = ({ intl }) => {
    return <Flex flexDirection='column'>
        <Box mb='0.5em'>
            <Flex flexDirection='column'>
                <Box w='100%' mb='0.5em'>
                    <Control
                      id='.password'
                      type='password'
                      model='.password'
                      autoComplete='off'
                      placeholder={intl.formatMessage(messages.placeholder)}
                      validators={{
                        required: required(),
                        password: password(),
                      }}
                      errorMessages={{
                          required: intl.formatMessage(messages.requiredError),
                          password: intl.formatMessage(messages.passwordError),
                      }}
                    />
                </Box>
                <Box w='100%'>
                    <Control
                      type='password'
                      id='.passwordRepeat'
                      model='.passwordRepeat'
                      placeholder={intl.formatMessage(messages.placeholderRepeat)}
                      autoComplete='off'
                      validators={{
                        required: required(),
                        password: password(),
                      }}
                      errorMessages={{
                        required: intl.formatMessage(messages.requiredError),
                        password: intl.formatMessage(messages.passwordError),
                        matchPassword: intl.formatMessage(messages.passwordMatch),
                      }}
                    />
                </Box>
            </Flex>
        </Box>
    </Flex>
}

PasswordFieldConfirm.propTypes = {
    intl: PropTypes.object,
}

PasswordFieldConfirm.defaultProps = {
    onBlur: () => {},
}

export default injectIntl(PasswordFieldConfirm)
